<template>
    <svg width="7px" height="7px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" >
      <path fill="currentColor" d="M8,0 C3.58064516,0 0,3.58064516 0,8 C0,12.4193548 3.58064516,16 8,16 C12.4193548,16 16,12.4193548 16,8 C16,3.58064516 12.4193548,0 8,0 Z"></path>
    </svg>
</template>

<script>
export default {
  name: 'EmdCircle'
}
</script>

<style>
</style>
